import {
    LandrSamplesBrand,
    StudioPlan,
    LandrBrand,
    SamplesProPlan,
    SamplesBrand,
} from 'constants/brands';
import {
    ArchiveOutlined,
    LogoOutlined,
    ReplaceOutlined,
    CalendarOutlined,
    HeadphonesAddOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { CONFIG } from 'utils/config';
import { PricingCardContent, Included } from './types';

const samplesIncluded: () => Included[] = () => [
    {
        icon: ArchiveOutlined,
        copy: t`Unlock the complete ${SamplesBrand} library`,
    },
    {
        icon: ReplaceOutlined,
        copy: t`1200 ${SamplesBrand} credits per year`,
        tooltip: t`Each sample is worth one (1) credit. All ${LandrSamplesBrand} are available for individual purchase. Unused credits rollover to the next billing cycle so you never waste a cent.`,
    },
    {
        icon: HeadphonesAddOutlined,
        copy: t`Make your own beats with Creator`,
    },
    {
        icon: CalendarOutlined,
        copy: t`Cancel any time`,
        tooltip: t`Cancel penalty-free whenever you need to. Your credits stay valid until the end of your billing cycle and you can re-subscribe at any time.`,
    },
];

const studioIncluded: () => Included[] = () => [
    {
        icon: LogoOutlined,
        copy: t`Access to all ${LandrBrand} products`,
        tooltip: t`${LandrBrand} ${StudioPlan} includes Mastering, Distribution, Plugins, Collaboration tools, ${SamplesBrand} and more!`,
    },
    {
        icon: ReplaceOutlined,
        copy: t`1200 ${SamplesBrand} credits per year`,
        tooltip: t`Unused credits rollover as long as your subscription is active.`,
    },
    {
        icon: HeadphonesAddOutlined,
        copy: t`Make your own beats with Creator`,
    },
    {
        icon: CalendarOutlined,
        copy: t`Cancel any time`,
        tooltip: t`Cancel or downgrade your plan whenever you need to.`,
    },
];

export const samplesPricing: (
    samplesMonthlyEquivalentPriceWithCurrency: string,
) => PricingCardContent = (samplesMonthlyEquivalentPriceWithCurrency) => ({
    heading: SamplesProPlan,
    byline: t`Stay ready for inspiration with access to over 2 millions samples starting at just ${samplesMonthlyEquivalentPriceWithCurrency}/mo.`,
    included: samplesIncluded(),
    ctaCopy: t`Starting at ${samplesMonthlyEquivalentPriceWithCurrency}/mo`,
    ctaLinkGuest: `${CONFIG.VITE_GUEST_PRICING_URL}/samples-en`,
    ctaLinkAuthenticated: `${CONFIG.VITE_PRICING_URL}/samples`,
    image: 'pricingCards/samples-pricing',
    filetype: 'jpg',
});

export const studioPricing: (
    studioMonthlyEquivalentPriceWithCurrency: string,
) => PricingCardContent = (studioMonthlyEquivalentPriceWithCurrency) => ({
    heading: `${LandrBrand} ${StudioPlan}`,
    byline: t`Get all the tools you need to create, produce and release music for just ${studioMonthlyEquivalentPriceWithCurrency}/mo.`,
    included: studioIncluded(),
    ctaCopy: t`Starting at ${studioMonthlyEquivalentPriceWithCurrency}/mo`,
    ctaLinkGuest: `${CONFIG.VITE_GUEST_PRICING_URL}/studio`,
    ctaLinkAuthenticated: `${CONFIG.VITE_PRICING_URL}/studio`,
    image: 'pricingCards/studio-pricing',
    filetype: 'jpg',
});
